export default {
  clearTip: '您确定要清空所有内容吗？',
  btnHeader: '标题',
  btnClear: '清空',
  btnBold: '加粗',
  btnItalic: '斜体',
  btnUnderline: '下划线',
  btnStrikethrough: '删除线',
  btnUnordered: '无序列表',
  btnOrdered: '有序列表',
  btnQuote: '引用',
  btnLineBreak: '换行',
  btnInlineCode: '行内代码',
  btnCode: '代码块',
  btnTable: '表格',
  btnImage: '图片',
  btnLink: '链接',
  btnUndo: '撤销',
  btnRedo: '重做',
  btnFullScreen: '全屏',
  btnExitFullScreen: '退出全屏',
  btnModeEditor: '仅显示编辑器',
  btnModePreview: '仅显示预览',
  btnModeAll: '显示编辑器与预览',
  selectTabMap: '按下 Tab 键时实际的输入',
  tab: '制表符',
  spaces: '空格'
};